/* eslint-disable */

import { Grid, IconButton, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { ArrowBack } from '@mui/icons-material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';


import PersonalDetailsForm from './PersonalDetailsForm1';
import CompanyDetails from './AddCompanyDetails';
import PackageLimitations from './PackageLimitations';
import AddDetailsForm from './AddDetailsForm';
import PaymentForm from './PaymentForm';
import EditCustomer from './EditCustomer';
import { closeUpgradeForm } from '../../reducers/upgradePlanReducer';
import Contract from '../Contracts/Contract';

const steps = ['Customer Details', 'Company Details', 'Package Limitations'];

const AddCustomerSteps = ({ setAddCustomerProcessStart, setAddCustomer, editCustomerData, setEditCustomerData }) => {
  const [step, setStep] = useState(0);
  const [addCustomerResponse, setAddCustomerResponse] = useState(null);
  const isOpenUpgradePaymentForm = useSelector(state => state.upgradePlan.isOpen);
  const upgradePlanData = useSelector(state => state.upgradePlan.planData);
  const dispatch = useDispatch();

  useEffect(() => {
    if(isOpenUpgradePaymentForm){
      stepHandler(upgradePlanData);
    }
  }, [isOpenUpgradePaymentForm])
  const cancelHandler = () => {
    setAddCustomer(false);
    setEditCustomerData(null);
    handleCloseForm();
  } 
  const handleCloseForm = () => {
    dispatch(closeUpgradeForm());
  };
  const stepHandler = (data, formData) => {
    setAddCustomerResponse(formData);
    setStep(1);
  }
  return (
    <Grid container component={Paper} sx={{ bgcolor:'#F2F4FA', pb:'10px', }}>
      <Grid item md={12}>
        <Box>
          <IconButton onClick={cancelHandler}>
          <ArrowBack  />
          </IconButton>
        </Box>
        {/* <Box sx={{ width: '100%', pt: 2 }}>
          <Stepper activeStep={step} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Box>
            {step === 0 ? 
            <PersonalDetailsForm cancelHandler={cancelHandler} stepHandler={stepHandler} />
             : step === 1 ? <CompanyDetails stepHandler={stepHandler} />
             : step === 2 ? <PackageLimitations />
              : <></>}</Box> */}
              <Box>
                {
                  editCustomerData ? <EditCustomer editCustomerData={editCustomerData} cancelHandler={cancelHandler} />
                  : step === 0
                   ?
                <AddDetailsForm cancelHandler={cancelHandler} stepHandler={stepHandler}  />
                : addCustomerResponse &&
                //  <PaymentForm addCustomerResponse={addCustomerResponse} /> 
                <Box component={Paper} elevation={1} sx={{m:'10px', p:'10px'}}>
                <Contract addCustomerResponse={addCustomerResponse} />

                </Box>
}
              </Box>
      </Grid>
    </Grid>
  );
};

export default AddCustomerSteps;
